export const validateNumber = (value: string) => {
  value = value.replace(/[^\d.-]/g, '');
  if (value.startsWith('0') && value.length === 2 && value[1] === '-') {
    value = '-';
  }
  if (value.indexOf('-') > 0) {
    value = value.replace('-', '');
  }
  const parts = value.split('.');
  if (parts.length > 1) {
    parts[1] = parts[1].slice(0, 2);
    value = parts[0] + '.' + parts[1];
  }
  if (value.length > 1 && value.startsWith('0') && value[1] !== '.') {
    value = value.replace(/^0+/, '');
  }

  return value;
};

export const formatNumberWithCommas = (x: any) => {
  const numberValue = Number(x);
  if (!isNaN(numberValue)) {
    return numberValue.toLocaleString();
  }
  return x;
};

export const getValueByPath = (obj: any, path: string) => {
  const keys = path.split(/[\.\[\]]/).filter(Boolean);
  return keys.reduce(
    (acc, key) => (acc && acc[key] !== undefined ? acc[key] : undefined),
    obj,
  );
};

export const getSuffixLabel = (
  currencySymbol: string | undefined,
  value: number,
  currencyRate: number | undefined,
  removeK?: boolean,
) => {
  if (removeK) return '';
  if (!currencySymbol || !currencyRate) return 'K';
  const formattedValue = formatNumberWithCommas(
    (value * currencyRate).toFixed(),
  );
  const convertedValue = currencySymbol !== '€' ? ` | ${formattedValue}K€` : '';
  return `K${currencySymbol}${convertedValue}`;
};
